/**
 * Shared returning-customer modal for the Otto configurator (used by plan-guard
 * on load and by the main bundle at the ZIP gate). Copy varies by planStatus:
 * ACTIVE, PAUSED, CANCELLED (and EXPIRED → cancelled messaging).
 */
(function () {
  function esc(val) {
    return String(val == null ? '' : val)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeStatus(status) {
    var st = String(status || 'ACTIVE').toUpperCase();
    if (st === 'EXPIRED') return 'CANCELLED';
    if (st === 'ACTIVE' || st === 'PAUSED' || st === 'CANCELLED') return st;
    return 'ACTIVE';
  }

  function greeting(firstName) {
    var first = String(firstName || '').trim();
    return first ? ('Hi ' + esc(first) + ' — ') : '';
  }

  function parseAccountCheckResponse(data) {
    var existing = !!(data && data.existingOttoPlan);
    var planStatus = existing
      ? normalizeStatus(data && data.planStatus ? data.planStatus : 'ACTIVE')
      : null;
    var firstName = data && data.firstName ? String(data.firstName).trim() : '';
    return { existingOttoPlan: existing, planStatus: planStatus, firstName: firstName };
  }

  function copyForStatus(status, opts) {
    opts = opts || {};
    var st = normalizeStatus(status);
    var greet = greeting(opts.firstName);
    var out = { title: '', body: '', primaryLabel: '', secondaryLabel: '', showStartFresh: false };

    if (st === 'ACTIVE') {
      out.title = 'Hang on a sec';
      out.body = greet + 'you already have an active <strong>otto</strong> subscription. Manage your pack, add dogs, or change your plan from your account — don\u2019t start a new one here.';
      out.primaryLabel = 'Manage My Pack';
      out.secondaryLabel = 'Continue Browsing';
      return out;
    }
    if (st === 'PAUSED') {
      out.title = 'Your subscription is paused';
      out.body = greet + 'your <strong>otto</strong> subscription is paused. Resume deliveries or manage your pack from your account.';
      out.primaryLabel = 'Manage My Pack';
      out.secondaryLabel = 'Continue Browsing';
      return out;
    }
    /* CANCELLED / EXPIRED */
    out.title = 'Welcome back';
    out.showStartFresh = true;
    if (opts.loggedIn) {
      out.body = greet + 'looks like you already have an <strong>otto</strong> account. To reactivate or manage a subscription, go to your account. To start fresh, sign up with a different email address.';
      out.primaryLabel = 'Reactivate In My Account';
      out.secondaryLabel = 'Start Fresh With A Different Email';
    } else {
      out.body = greet + 'looks like you already have an <strong>otto</strong> account. To reactivate or manage a subscription, log in to your account. To start fresh, sign up with a different email address.';
      out.primaryLabel = 'Log In To My Account';
      out.secondaryLabel = 'Start Fresh With A Different Email';
    }
    return out;
  }

  function bannerCopy(status, opts) {
    opts = opts || {};
    var st = normalizeStatus(status);
    var first = String(opts.firstName || '').trim();
    var nameBit = first ? (', ' + esc(first)) : '';
    if (st === 'ACTIVE') {
      return 'You already have an active Otto plan' + nameBit + '. Manage your pack from your account — don\u2019t start a new plan here.';
    }
    if (st === 'PAUSED') {
      return 'Your Otto subscription is paused' + nameBit + '. Resume or manage your pack from your account.';
    }
    return 'You already have an Otto account' + nameBit + '. Log in to reactivate, or use a different email to start fresh.';
  }

  function manageUrl(opts) {
    opts = opts || {};
    var portal = (opts.urls && opts.urls.portal) || '/pages/manage-subscription';
    if (opts.loggedIn) return portal;
    var login = (opts.urls && opts.urls.login) ||
      ('/customer_authentication/login?return_to=' + encodeURIComponent(portal));
    var hint = String(opts.emailVal || '').trim();
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(hint)) {
      login += '&login_hint=' + encodeURIComponent(hint);
    }
    return login;
  }

  function continueBrowsingUrl() {
    var dest = '/';
    try {
      var ref = document.referrer;
      if (ref) {
        var u = new URL(ref);
        if (u.origin === window.location.origin && u.pathname !== window.location.pathname) {
          dest = ref;
        }
      }
    } catch (e) {}
    return dest;
  }

  /** Shopify account logout that returns to the current configurator URL. */
  function logoutHref(opts) {
    opts = opts || {};
    var logoutBase = (opts.urls && opts.urls.logout) || '/account/logout';
    var returnPath = window.location.pathname + window.location.search;
    var sep = logoutBase.indexOf('?') >= 0 ? '&' : '?';
    return logoutBase + sep + 'return_url=' + encodeURIComponent(returnPath);
  }

  function getFocusable(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll(
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      if (el.hasAttribute('disabled') || el.getAttribute('aria-hidden') === 'true') return false;
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    });
  }

  function restoreFocus(el) {
    if (!el || typeof el.focus !== 'function') return;
    try { el.focus(); } catch (e) {}
  }

  function focusInitial(overlay) {
    var focusables = getFocusable(overlay);
    if (focusables.length) {
      try { focusables[0].focus(); } catch (e) {}
      return;
    }
    var dialog = overlay.querySelector('.otto-cfg-plan-modal__dialog');
    if (!dialog) return;
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    try { dialog.focus(); } catch (e) {}
  }

  function dismissModal() {
    var existing = document.querySelector('.otto-cfg-plan-modal');
    var restoreEl = existing && existing.__ottoPlanRestoreFocus;
    if (existing) {
      if (existing.__ottoPlanKeydown) {
        document.removeEventListener('keydown', existing.__ottoPlanKeydown);
      }
      if (existing.parentNode) existing.parentNode.removeChild(existing);
    }
    if (document.documentElement) document.documentElement.classList.remove('otto-cfg-plan-modal-open');
    window.__ottoPlanModalShown = false;
    restoreFocus(restoreEl);
  }

  function wireModal(overlay, opts, copy) {
    overlay.__ottoPlanRestoreFocus =
      document.activeElement && document.activeElement !== document.body
        ? document.activeElement
        : null;

    function onContinueBrowsing() {
      dismissModal();
      if (typeof opts.onContinueBrowsing === 'function') opts.onContinueBrowsing();
      else window.location.href = continueBrowsingUrl();
    }
    function onStartFresh() {
      dismissModal();
      if (typeof opts.onStartFresh === 'function') opts.onStartFresh();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') {
        if (copy.showStartFresh) onStartFresh();
        else onContinueBrowsing();
        return;
      }
      if (e.key !== 'Tab') return;
      var focusables = getFocusable(overlay);
      if (!focusables.length) {
        e.preventDefault();
        focusInitial(overlay);
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first || !overlay.contains(document.activeElement)) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last || !overlay.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    }

    var backdrop = overlay.querySelector('.otto-cfg-plan-modal__backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', copy.showStartFresh ? onStartFresh : onContinueBrowsing);
    }
    var continuers = overlay.querySelectorAll('[data-otto-plan-continue]');
    for (var i = 0; i < continuers.length; i++) {
      continuers[i].addEventListener('click', onContinueBrowsing);
    }
    var freshBtns = overlay.querySelectorAll('[data-otto-plan-start-fresh]');
    for (var j = 0; j < freshBtns.length; j++) {
      freshBtns[j].addEventListener('click', onStartFresh);
    }
    document.addEventListener('keydown', onKeydown);
    overlay.__ottoPlanKeydown = onKeydown;

    requestAnimationFrame(function () { focusInitial(overlay); });
  }

  function showModal(opts) {
    opts = opts || {};
    dismissModal();
    window.__ottoPlanModalShown = true;

    var copy = copyForStatus(opts.planStatus, opts);
    var primaryHref = esc(manageUrl(opts));
    var secondaryAttr = copy.showStartFresh ? 'data-otto-plan-start-fresh' : 'data-otto-plan-continue';
    var backdropDismiss = copy.showStartFresh ? '' : ' data-otto-plan-continue';
    var titleId = 'otto-cfg-plan-modal-title';
    var logoutHtml = opts.loggedIn
      ? ('<p class="otto-cfg-plan-modal__logout-wrap">' +
          '<a class="otto-cfg-plan-modal__logout" href="' + esc(logoutHref(opts)) + '" data-no-instant>Log out of account</a>' +
        '</p>')
      : '';

    var overlay = document.createElement('div');
    overlay.className = 'otto-cfg-plan-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', titleId);
    overlay.innerHTML =
      '<div class="otto-cfg-plan-modal__backdrop"' + backdropDismiss + '></div>' +
      '<div class="otto-cfg-plan-modal__dialog" role="document">' +
        '<h2 class="otto-cfg-plan-modal__title" id="' + titleId + '">' + esc(copy.title) + '</h2>' +
        '<p class="otto-cfg-plan-modal__body">' + copy.body + '</p>' +
        '<div class="otto-cfg-plan-modal__actions">' +
          '<a class="otto-cfg-plan-modal__btn otto-cfg-plan-modal__btn--primary" href="' + primaryHref + '">' + esc(copy.primaryLabel) + '</a>' +
          '<button type="button" class="otto-cfg-plan-modal__btn otto-cfg-plan-modal__btn--ghost" ' + secondaryAttr + '>' + esc(copy.secondaryLabel) + '</button>' +
        '</div>' +
        logoutHtml +
      '</div>';

    document.body.appendChild(overlay);
    if (document.documentElement) document.documentElement.classList.add('otto-cfg-plan-modal-open');
    wireModal(overlay, opts, copy);
  }

  function showChecking() {
    dismissModal();
    window.__ottoPlanModalShown = true;
    var overlay = document.createElement('div');
    overlay.className = 'otto-cfg-plan-modal otto-cfg-plan-modal--checking';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Checking your account');
    overlay.innerHTML =
      '<div class="otto-cfg-plan-modal__backdrop"></div>' +
      '<div class="otto-cfg-plan-modal__dialog" role="document" tabindex="-1">' +
        '<p class="otto-cfg-plan-modal__checking">Checking your account\u2026</p>' +
      '</div>';
    document.body.appendChild(overlay);
    if (document.documentElement) document.documentElement.classList.add('otto-cfg-plan-modal-open');
    overlay.__ottoPlanRestoreFocus =
      document.activeElement && document.activeElement !== document.body
        ? document.activeElement
        : null;
    function onKeydown(e) {
      if (e.key === 'Tab') {
        e.preventDefault();
        focusInitial(overlay);
      }
    }
    document.addEventListener('keydown', onKeydown);
    overlay.__ottoPlanKeydown = onKeydown;
    requestAnimationFrame(function () { focusInitial(overlay); });
  }

  window.OttoCfgPlanModal = {
    parseAccountCheckResponse: parseAccountCheckResponse,
    copyForStatus: copyForStatus,
    bannerCopy: bannerCopy,
    show: showModal,
    showChecking: showChecking,
    dismiss: dismissModal,
    manageUrl: manageUrl,
  };
})();
